import Cart from "../../models/cart";
import PickingProgress from '../../models/pick-progress';
import MoveItemToCartResponse from "../../models/response/move-item-to-cart-response";
import StageCartResponse from "../../models/response/stage-cart-response";
import PicklistInfo from "../../models/picklist-info";
import ReportIssueForItemResponse from "../../models/response/report-issue-for-item-response";

class PickApisMock {

    delayed = async (msg) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(msg);
            }, 2000);
        });
    }

    getRequestPickList = async (routeCode) => {
        return routeCode ? this.assignPickList(routeCode) : this.assignTopPriorityPickList();
    }

    assignPickList = async (routeCode) => {
        return this.delayed(new PicklistInfo());
    }

    assignTopPriorityPickList = async () => {
        return this.delayed(new PicklistInfo());
    }

    reportIssueForItem = async (picklistId, itemId, issueType, problemSolveId) => {
        return this.delayed(new ReportIssueForItemResponse());
    }

    addCartToPicklist = async (cartId, picklistId) => {
        return this.delayed(new Cart());
    }

    moveItemToCart = async (cartId, picklistId, itemId) => {
        return this.delayed(new MoveItemToCartResponse());
    }

    reportIssueForCart = async (cartId, picklistId, issueType) => {
        return this.delayed(new PickingProgress());
    }

    stageCart = async (cartId, picklistId, stageId, isPreStaging) => {
        return this.delayed(new StageCartResponse());
    }

//    list of APIs not implemented
//     "sps/cart/moveFromFloor" - staging
//     "sps/route/staging/end/notify" - SSP
//     "sps/route/picking/end/notify" - SSP
//     "sps/route/picking/start/notify" - SSP
//     "sps/assign/route" - SSP
//     "sps/assign/priorityRoute" - RPS
}

const PickApisMockInstance = new PickApisMock();
export default PickApisMockInstance;


// WEBPACK FOOTER //
// ./src/network/mock/pick-apis-mock.js